export const POST_VALIDATE_UNIQUE_LINK = '/payments/validate-unique-link';
export const POST_OFFLINE = '/payment/offline';
export const POST_GENERATE_PAYNOW_QR = '/paynow/generate-paynow-qr';
export const GET_PAYNOW_STATUS = '/paynow/status';
export const POST_UPDATE_TRANSACTION_NUMBER = '/payments/update-transaction-number';
